import { EnterpriseProfilePrivileges as EnterpriseProfilePrivilegesEnum } from '@mews-commander/data-access';
import { enumify, Enumify, EnumValue } from '@mews/enumify';

export type EnterpriseProfilePrivilegesFlagNames = Exclude<
    keyof EnterpriseProfilePrivilegesEnum,
    'manageCustomers' | 'manageCompanies' // deprecated fields in the API
>;

export type EnterpriseProfilePrivilegesEnumNames = Capitalize<EnterpriseProfilePrivilegesFlagNames>;

export type EnterpriseProfilePrivilegesEnumValue = EnumValue<
    EnterpriseProfilePrivilegesEnumNames,
    EnterpriseProfilePrivilegesEnumNames
>;

function EnterpriseProfilePrivileges() {}
enumify<EnterpriseProfilePrivilegesEnumNames, EnterpriseProfilePrivilegesEnumNames>(
    EnterpriseProfilePrivileges,
    'EnterpriseProfilePrivileges',
    {
        ChargeCardsOnline: 'ChargeCardsOnline',
        ConfigureEnterprise: 'ConfigureEnterprise',
        IssueInvoices: 'IssueInvoices',
        ManageCompanyContracts: 'ManageCompanyContracts',
        ManageInvoiceability: 'ManageInvoiceability',
        ManageReservations: 'ManageReservations',
        ManageProfiles: 'ManageProfiles',
        ManageSpaces: 'ManageSpaces',
        ManageSellLimits: 'ManageSellLimits',
        OverrideRestrictions: 'OverrideRestrictions',
        OverbookServices: 'OverbookServices',
        PerformHousekeeping: 'PerformHousekeeping',
        ViewSensitiveReports: 'ViewSensitiveReports',
        ViewCustomerData: 'ViewCustomerData',
        ViewCompanyData: 'ViewCompanyData',
        ManageServices: 'ManageServices',
        ManageResourceCategories: 'ManageResourceCategories',
        ManageProducts: 'ManageProducts',
        ManageBusinessSegments: 'ManageBusinessSegments',
        ManageRateGroups: 'ManageRateGroups',
        ManageProductRules: 'ManageProductRules',
        ManageRates: 'ManageRates',
        ManageRestrictions: 'ManageRestrictions',
        ManageServiceConfigurations: 'ManageServiceConfigurations',
        ManageAvailability: 'ManageAvailability',
        ManageAccountingCategories: 'ManageAccountingCategories',
        ManageAccountingConfiguration: 'ManageAccountingConfiguration',
        ManageCounters: 'ManageCounters',
        ManageOutlets: 'ManageOutlets',
        ManageDepartments: 'ManageDepartments',
        RebateItems: 'RebateItems',
        ManageAvailabilityBlockRates: 'ManageAvailabilityBlockRates',
        ManageAccounts: 'ManageAccounts',
        ManageLoyaltyMemberships: 'ManageLoyaltyMemberships',
        ManageMailQueue: 'ManageMailQueue',
        OverrideRatePrice: 'OverrideRatePrice',
        RequestInstantPayouts: 'RequestInstantPayouts',
        ManagePaymentAndCancellationPolicies: 'ManagePaymentAndCancellationPolicies',
        ClearCustomerData: 'ClearCustomerData',
        ManageMailTemplates: 'ManageMailTemplates',
    }
);

export default EnterpriseProfilePrivileges as unknown as Enumify<
    EnterpriseProfilePrivilegesEnumNames,
    EnterpriseProfilePrivilegesEnumNames
>;
